import Entity from "../Entity";

describe("Entity model", () => {
  test("belongsTo relations", () => {
    expect(Entity.belongsTo.map(relation => relation.name)).toMatchSnapshot();
  });
});
